export const DCYB_PLATFORM = {
  symbol: "DCYB",
  name: "Data Center Youngbloods",
  stage: "Early-Stage Platform",
  ownership: "Private",
  status: "Private · Early-Stage Platform",
  mark: "/dcyb-mark.png",
  logo: "/dcyb-logo.png",
  wordmark: "/dcyb-wordmark.png",
};

export const openInvestorDeck = () => {
  const el = document.getElementById("deck");
  if (!el) {
    window.location.assign("/decks?open=investor");
    return;
  }
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent("dcyb:open-deck", { detail: { key: "investor" } }));
  }, 350);
};
